const dev = {
  s3: {
    BUCKET: "staging.petpos.com"
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "http://localhost:9000"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_8zfizKghP",
    APP_CLIENT_ID: "46u4ovp5at4pu12t10mfemvk3s",
    IDENTITY_POOL_ID: "us-east-1_8zfizKghP"
  },
  stripeConfig: {
    publisher_key: 'pk_test_Nf0oIUx2dvDVq6jxnkoBDt0j',
    secretKey: 'sk_test_ZKuoWf3Z7Ekg4r75fyPRelmw'
  },
  daysForAvailability: 1,
  petDobValidateTo: 7,
  petDobValidateFrom: 180,
  changelogNotifyDays :3,
  petArrivalDateInWeeksFromDOB : 8,
  videoUploader : {
    wistia:{ 
      project_id: "f0dzov1qfj",
      access_token:"e5ce2612a0b8980a191f8a0d1350763ffe20736a6292ef838636302804bb6370",
    },
    vimeo:{  
      access_token:"2f3b80ca5c1f17f2e2e67e01182b6f12"
    }
  },
  zipCodeApi: {
     applicationKey : 'wuYP6OBDzW8uN0Kz8qv2Ij2F2GTKzzlzMAQuOfBRcv6UQYtkbc9UZvMIqulkCAJU',
     clientKey : 'js-gvflD2hGLjgFqCForvGRXRkxuYjHilT4SOWCUmSAIrj0Zk2BynkqGQruEfjTsLIz'
  },
  wooConfig: {
    siteUrl: "http://localhost/live-centralpups-wp",
  },
  signaturePath:"https://s3.amazonaws.com/uploads.development.petpos/signature/signature-100x31.png",
  financingPaymentMethods: ["Financing","LendingUSA","UCFS","Klarna"],
  
};

const stg = {
  s3: {
    BUCKET: "staging.petpos.com"
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "http://localhost:9000"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_efF9VHNHt",
    APP_CLIENT_ID: "3md9hu5jc3bh76iqfi98qllg05",
    IDENTITY_POOL_ID: ""
  },
  stripeConfig: {
    publisher_key: 'pk_test_Nf0oIUx2dvDVq6jxnkoBDt0j',
    secretKey: 'sk_test_ZKuoWf3Z7Ekg4r75fyPRelmw'
  },
  daysForAvailability: 1,
  petDobValidateTo: 7,
  petDobValidateFrom: 180,
  changelogNotifyDays :3,
  petArrivalDateInWeeksFromDOB : 8,
  videoUploader : {
    wistia:{ 
      project_id: "f0dzov1qfj",
      access_token:"e5ce2612a0b8980a191f8a0d1350763ffe20736a6292ef838636302804bb6370",
    },
    vimeo:{  
      access_token:"2f3b80ca5c1f17f2e2e67e01182b6f12"
    }
  },
  zipCodeApi: {  
     applicationKey : 'wuYP6OBDzW8uN0Kz8qv2Ij2F2GTKzzlzMAQuOfBRcv6UQYtkbc9UZvMIqulkCAJU',
     clientKey : 'js-gvflD2hGLjgFqCForvGRXRkxuYjHilT4SOWCUmSAIrj0Zk2BynkqGQruEfjTsLIz'
  },
  wooConfig: {
    siteUrl: "https://base.petposdev.com",
  },
  signaturePath:"https://s3.amazonaws.com/uploads.development.petpos/signature/signature-100x31.png",
  financingPaymentMethods: ["Financing","LendingUSA","UCFS","Klarna"],
};

const prod = {
  s3: {
    BUCKET: "staging.petpos.com"
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "http://localhost:9000"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_8zfizKghP",
    APP_CLIENT_ID: "46u4ovp5at4pu12t10mfemvk3s",
    IDENTITY_POOL_ID: "us-east-1_8zfizKghP"
  },
  stripeConfig: {
    publisher_key: 'pk_test_Nf0oIUx2dvDVq6jxnkoBDt0j',
    secretKey: 'sk_test_ZKuoWf3Z7Ekg4r75fyPRelmw'
  },
  daysForAvailability: 1,
  petDobValidateTo: 7,
  petDobValidateFrom: 180,
  changelogNotifyDays :3,
  petArrivalDateInWeeksFromDOB : 8,
  videoUploader : {
    wistia:{ 
      project_id: "b2rstcyesf",
      access_token:"f8014bd8e2f02f7b6b4894fccd3ba8a8a867a266c7a966210b957df3c8c3f735",
    },
    vimeo:{  
      access_token:"ac46c18d0bb11cd67a9c3a9d7079f0e8"
    }
  },
 zipCodeApi: {  
  applicationKey : 'FhvFsvE8goNp8f8mmAlAkwu0I24ew7mzjEHhcWaT4TZYZqcEzzW19Q4cma8lN6d6',
  clientKey: 'js-sG1mFrnjyP88tbpc269kLQbvPWCxFM7gvrNQLp3Wh2HjM5WyPZTaLIpIZlYAeoC5'  
},
wooConfig: {
  siteUrl: "https://centralparkpuppies.com",
},
signaturePath:"https://s3.amazonaws.com/uploads.development.petpos/signature/signature-100x31.png",
financingPaymentMethods: ["Financing","LendingUSA","UCFS","Klarna"],
};
  let config = null;
    switch(process.env.REACT_APP_ENV){
      case "production": 
        config = prod;
        break;
      case "local": 
        config = dev;
        break;
      case "development": 
        config = dev;
        break;  
      case "staging": 
        config = stg;
        break;
      default:
        config = dev;  
    }
  
  export default {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: 5000000,
    ...config
  };